import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Grid } from "@material-ui/core"
import { ButtonHLPure, HeaderHLPure, InputHLPure } from "../../pures"
import Geocoder from "./geocode/geocode-map"
import "./branch-office-details.css"
import { useHistory } from "react-router-dom"

const BranchOfficeDetailsView = (props) => {
  const history = useHistory()
  const { t: transl } = useTranslation('branch-office', { keyPrefix: 'branchOfficeDetails' })
  const {
    nameRef,
    keyIdentifierRef,
    zipCodeRef,
    cityRef,
    stateRef,
    countryRef,
    branchOfficeId,
    edit,
    onClickPrimaryButton,
    setCoordinates,
    setFullAddress,
    coordinates
  } = props

  let type = 'add'
  let title = ''
  const optionsTitle = {
    show: transl('branchOfficeTitle.show'),
    edit: transl('branchOfficeTitle.edit'),
    add: transl('branchOfficeTitle.add')
  }

  if (!edit && branchOfficeId) {
    title = optionsTitle.show
    type = 'show'
  } else if (edit && branchOfficeId) {
    title = optionsTitle.edit
    type = 'edit'
  } else {
    title = optionsTitle.add
    type = 'add'
  }

  const typeActionValidation = (type === 'show')
  let styleInputType = {}
  if (typeActionValidation) styleInputType = { backgroundColor: '#fafafa00', border: 'none', color: '#080808' }

  const search = ['add', 'edit'].includes(type)

  const onCancel = () => history.goBack()

  return (
    <Container className="branchOfficeDetailsView view-container">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderHLPure title={title} />
        </Grid>
        <Grid item xs={12}>
          <Container maxWidth={"md"}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <InputHLPure
                  labelInput={transl('input.name')}
                  typeInput="text"
                  ref={nameRef}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputHLPure
                  labelInput={transl('input.keyIdentifier')}
                  typeInput="text"
                  ref={keyIdentifierRef}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>
              <Grid item xs={12} style={{ height: 300 }}>
                <Geocoder
                  data={[]}
                  addressRefs={{
                    setCoordinates,
                    zipCodeRef,
                    cityRef,
                    stateRef,
                    countryRef,
                    setFullAddress
                  }}
                  search={search}
                  coordinates={coordinates}
                />
              </Grid>
              <Grid item xs={6}>
                <InputHLPure
                  labelInput={transl('input.zipCode')}
                  typeInput="text"
                  ref={zipCodeRef}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>
              <Grid item xs={6}>
                <InputHLPure
                  labelInput={transl('input.city')}
                  typeInput="text"
                  ref={cityRef}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>
              <Grid item xs={6}>
                <InputHLPure
                  labelInput={transl('input.state')}
                  typeInput="text"
                  ref={stateRef}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>
              <Grid item xs={6}>
                <InputHLPure
                  labelInput={transl('input.country')}
                  typeInput="text"
                  ref={countryRef}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                  tooltipShow
                  informationIcon
                  descriptionTooltip={transl('countryTooltip')}
                />
              </Grid>
              <Grid item xs={12} className="button-actions">
                <ButtonHLPure colorScheme="error" outlined
                  nameBtn={typeActionValidation ? transl('button.goBack') : transl('button.cancel')}
                  onClick={onCancel}
                />
                <ButtonHLPure primary outlined
                  nameBtn={typeActionValidation ? transl('button.edit') : transl('button.save')}
                  onClick={onClickPrimaryButton}
                />
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
}

export { BranchOfficeDetailsView as default };